import styled from "@emotion/styled";
import React from "react";
import { Button } from "../Button";
import { Typography } from "../Typography";
import { useIsDesktopUp, useIsTabletUp } from "../utils/use-media-breakpoints";

const HoldingPageWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  position: relative;

  background: rgb(244, 242, 240);
  background: linear-gradient(
    0deg,
    rgba(244, 242, 240, 1) 12%,
    rgba(19, 171, 219, 1) 100%
  );
`;

const HoldingPageContent = styled.div`
  text-align: center;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  width: 100vw;
  overflow: hidden;
`;

const TextWrapper = styled.div`
  p {
    margin: 32px 0 24px 0;
  }

  padding: 24px;
  @media ${({ theme }) => theme.bp.tabletUp} {
    padding: 0;
  }

  margin: 156px auto 280px;

  @media ${({ theme }) => theme.bp.tabletUp} {
    margin: 156px auto 0;
  }
`;

const Title = styled(Typography)`
  font-size: 48px !important;
  margin-bottom: 14px;
  line-height: 48px !important;
`;

const Mountains = styled.img`
  position: absolute;
  bottom: -4px;
  width: 100%;
  height: auto;
`;

const Left = styled.img`
  height: 90vh;
  width: auto;
  margin-top: auto;
  flex-shrink: 0;
`;

const Right = styled.img`
  height: 100vh;
  width: auto;
  flex-shrink: 0;
`;

const RightSmall = styled.img`
  height: 65vh;
  width: auto;
  position: absolute;
  bottom: 0;
  right: 0;
`;

const Clouds = styled.img`
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  margin: auto;
`;

export interface HoldingPageProps {
  title?: string;
  bodyText?: string;
  ctaText?: string;
  ctaLink?: string;
}

export const HoldingPage = ({
  title = "Check back soon",
  bodyText = "We're sorry that this page is currently out of action while we make some improvements. It will be back up and running soon. If you need immediate help, please get in touch at support@ecologi.com.",
  ctaText = "Back to homepage",
  ctaLink = "/",
}: HoldingPageProps) => {
  const isDesktopUp = useIsDesktopUp();
  const isTabletUp = useIsTabletUp();

  return (
    <HoldingPageWrapper>
      {isDesktopUp && <Clouds src="/images/app/holding-page/clouds.svg" />}
      <Mountains src="/images/app/holding-page/mountains.svg" />

      <HoldingPageContent>
        {isTabletUp && <Left src="/images/app/holding-page/left.svg" />}

        <TextWrapper>
          <Title use="dashboardTitle2" as="h2">
            {title}
          </Title>
          <Typography use="subtitle2" as="p">
            {bodyText}
          </Typography>
          {ctaText && ctaLink && (
            <Button href={ctaLink} text={ctaText} primary />
          )}
        </TextWrapper>

        {isTabletUp ? (
          <Right src="/images/app/holding-page/right.svg" />
        ) : (
          <RightSmall src="/images/app/holding-page/right-small.svg" />
        )}
      </HoldingPageContent>
    </HoldingPageWrapper>
  );
};
